import {
  lowercaseRegex,
  numberRegex,
  passMinLength,
  specialCharacterRegex,
  uppercaseRegex,
} from "./Helpers";

export interface PasswordStrengthMessages {
  minLengthPrefix: string;
  minLengthSuffix: string;
  minUppercase: string;
  minLowercase: string;
  minNumber: string;
  minSpecial: string;
}

// Reglas de complejidad compartidas por cualquier formulario que establezca una
// contraseña nueva (editar perfil, admin crear/editar usuario...). No aplica al
// login: ahí se introduce una contraseña ya existente, no una nueva a ciegas.
export const validatePasswordStrength = (
  value: string,
  messages: PasswordStrengthMessages
): string => {
  const errorMessages: string[] = [];

  if (value.length < passMinLength) {
    errorMessages.push(
      `${messages.minLengthPrefix} ${passMinLength} ${messages.minLengthSuffix}`
    );
  }
  if (!uppercaseRegex.test(value)) {
    errorMessages.push(messages.minUppercase);
  }
  if (!lowercaseRegex.test(value)) {
    errorMessages.push(messages.minLowercase);
  }
  if (!numberRegex.test(value)) {
    errorMessages.push(messages.minNumber);
  }
  if (!specialCharacterRegex.test(value)) {
    errorMessages.push(messages.minSpecial);
  }

  return errorMessages.length === 0 ? "" : errorMessages.join("\r\n· ");
};
